import {createAction} from "redux-actions";
import * as ACTION from "../constants";

export const fetchListWarehouse = createAction(ACTION.FETCH_LIST_WAREHOUSE.REQUEST, (params) => params);
